import { render, staticRenderFns } from "./tickets-list-skeleton.vue?vue&type=template&id=fa597c7e"
import script from "./tickets-list-skeleton.vue?vue&type=script&lang=js"
export * from "./tickets-list-skeleton.vue?vue&type=script&lang=js"
import style0 from "./tickets-list-skeleton.vue?vue&type=style&index=0&id=fa597c7e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports